import { render, staticRenderFns } from "./ActionComment.vue?vue&type=template&id=c4d311de&scoped=true"
import script from "./ActionComment.vue?vue&type=script&lang=js"
export * from "./ActionComment.vue?vue&type=script&lang=js"
import style0 from "./ActionComment.vue?vue&type=style&index=0&id=c4d311de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d311de",
  null
  
)

export default component.exports